import React, { useEffect, useState } from "react";
import { Form, Input, Checkbox } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassParticipantDetails, 
	doTrainingClassParticipantCreate, 
	doTrainingClassParticipantUpdate,  
} from "../../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { User } from "lucide-react";
import SearchFilter from "components/search/SearchFilter";



const TrainingClassParticipantForm = ({
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData,
	classeId,
	getDetails,
	submitLabel,
	...props
 }) => {
		
  	const [form] = Form.useForm();
  	const { recordId, mode } = props;
	const [selectedParticipants, setSelectedParticipants] = useState([]);
	const [keyword, setKeyword] = useState("");

	
	useEffect(() => {	
	if (recordData) {
		form.resetFields();
			
			const { class_participants, ...rest } = recordData;

			const initialValues = {
				...rest,
				tcp_class_id: classeId,
				tcp_user_id: class_participants?.map(p => p.tcp_user_id) || [],
			};

			form.setFieldsValue(initialValues);
		}
	}, [recordData, classeId, form]);

	useEffect(() => {
		if (classeId && recordId === 0) {
			getDetails({ classeId, participantId: 0 });
		} else if (classeId && recordId) {
			getDetails({ classeId, participantId: recordId });
		}
	}, [classeId, recordId, getDetails]);

	const toggleModule = (participantId) => {
		setSelectedParticipants((prev) =>
			prev.includes(participantId)
				? prev.filter((id) => id !== participantId)
				: [...prev, participantId]
			);
	};

	const onSubmit = (formData) => {
		try { 
			formData.tcp_class_id=classeId;
			formData.tcp_user_id = selectedParticipants;

		if (!formData.tcp_user_id || formData.tcp_user_id === 0) {
      		delete formData.tcp_user_id;}

			recordData?.tcp_id > 0 ? doUpdate(formData): doCreate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	const filteredParticipants =
	recordData?.participantList?.filter((participant) => {
		const search = keyword.toLowerCase().trim();

		return (
			participant.label?.toLowerCase().includes(search)
		);
	}) || [];

  	return (
		<Form 	
			layout="vertical"
			form={form}
			onFinish={onSubmit}
			className={mode !== "view" ? "form" : ""}
		>

			<FormItem 
				name="tcp_id" 
				hidden
			>
				<Input type="hidden" />

			</FormItem>

			<div>
				<FormItem
					name="tcp_user_id"
				>
					<div className="flex flex-col gap-3 mb-3">
						<h1 className="text-slate-900 dark:text-slate-50">
							Participant List
						</h1>

						<SearchFilter
							placeholder="Search by name..."
							searchHandler={(data) => setKeyword(data.keyword)}
						/>
					</div>
					<div className="h-[340px] overflow-auto space-y-3 mt-2 pr-2">
						{filteredParticipants.length > 0 ? (
							filteredParticipants.map((participant) => {
								const selected = selectedParticipants.includes(participant.value);
								const disabled = participant.disabled;
								return (
									<div
										key={participant.value}
										className={`flex items-center gap-3 p-2.5 rounded-xl border-2 transition-all
											${disabled
												? "opacity-50 cursor-not-allowed border-slate-200 bg-slate-50"
												: selected
												? "border-green-500 bg-green-50 cursor-pointer"
												: "border-slate-200 hover:border-emerald-300 hover:bg-slate-50 cursor-pointer dark:hover:bg-slate-900"
											}`}
										onClick={() => !disabled && toggleModule(participant.value)} 
									>
										<Checkbox
											checked={selected}
											disabled={disabled}
											onChange={() => toggleModule(participant.value)}
											className="emerald-checkbox"
										/>
										<div
											className={`flex items-center justify-center w-10 h-10 border-2 border-white rounded-full text-[11px] font-semibold transition-all duration-300
												${disabled
												? "bg-gray-200 text-gray-400 cursor-not-allowed"
												: selected
													? "bg-gradient-to-br from-emerald-500 to-cyan-500 text-white"
													: "bg-emerald-100 text-emerald-700 shadow-sm"
												}`}
										>
											{participant.profile_initials}
										</div>
										<div className="flex-1 min-w-0">
											<p className="font-semibold text-[13px] truncate title-text">{participant.label}</p>
											<p className="text-[11px] truncate muted-text">{participant.employee_title}</p>
										</div>
									</div>
								);
							})
						) 	: 	(
							<div className="flex flex-col items-center justify-center py-12 text-center">
								<User className="w-8 h-8 text-slate-900 mx-auto mb-4"/>
								<p className="text-slate-700">No participant found</p>
							</div>
						)}
					</div>
				</FormItem>
			</div>

			{mode === "edit" && (
				<div className="w-full flex justify-end">
					<CrudButtons
						mode={mode}
						recordId={recordData?.tcp_id ?? 0}
						isModal={true}
						allowEdit={false}
						modalId={
						recordData?.tcp_id > 0
							? "edit_class_participants"
							: "add_class_participants"
						}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
					/>
				</div>
			)}
		</Form> 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassParticipantDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getTrainingClassParticipantDetails(data)),
  	doCreate: (data) => dispatch(doTrainingClassParticipantCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassParticipantUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassParticipantForm);
